import { render, staticRenderFns } from "./deleteStaff.vue?vue&type=template&id=394050f8&scoped=true"
import script from "./deleteStaff.vue?vue&type=script&lang=js"
export * from "./deleteStaff.vue?vue&type=script&lang=js"
import style0 from "./deleteStaff.vue?vue&type=style&index=0&id=394050f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394050f8",
  null
  
)

export default component.exports